module.exports = __webpack_public_path__ + "img/bomb.53d23667.svg";